"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_ANSWERS = exports.GET_QUESTIONS = exports.DOCUMENTS = void 0;
const GET_QUESTIONS = exports.GET_QUESTIONS = 'getQuestions';
const POST_ANSWERS = exports.POST_ANSWERS = 'postAnswers';
const DOCUMENTS = exports.DOCUMENTS = 'documents';